// node_modules
import axios from "axios";

export class AxiosHelper {
    public getServerBaseURL(): string {
        return `https://${window.location.host}/`;
    }

    public setCommonHeaderConfigDefaults(commonHeaderName: string, commonHeaderValue: string): void {
        axios.defaults.headers.common[commonHeaderName] = commonHeaderValue;
    }
}

export const AxiosHelperSingleton = new AxiosHelper();